import { DateTime } from 'luxon';
import { defineMessages } from 'react-intl';
import type { CollectionTicketClaimMemberStateDTOState } from '@/api/trafikportalen';
import { getMembershipStatus } from '@/helpers/membershipStatus';

const REVOKED_CLAIM_STATES: CollectionTicketClaimMemberStateDTOState[] = [
  'fulfilled',
  'purchase-ordered',
];

export const ticketRevocationMessages = defineMessages({
  label: {
    defaultMessage: 'Makuleras',
  },
  description: {
    defaultMessage: 'Eleven inaktiveras {date}',
  },
  reason: {
    defaultMessage: 'Biljetten makuleras eftersom eleven inaktiveras {date}.',
  },
});

export const claimStateRevokedBecauseStudentWillInactivate = (
  state: CollectionTicketClaimMemberStateDTOState,
  membership: { active: boolean; inactivate_at?: string },
) =>
  getMembershipStatus(membership) === 'will-inactivate' &&
  REVOKED_CLAIM_STATES.includes(state);

export const issuedTicketRevokedBecauseStudentWillInactivate = (
  ticket: {
    state: string;
    expires_at?: string;
    collection_ticket_claim_id?: string;
  },
  inactivateAt?: string,
) => {
  if (!inactivateAt) return false;
  if (ticket.state !== 'active' && ticket.state !== 'inactive') return false;
  if (
    getMembershipStatus({ active: true, inactivate_at: inactivateAt }) !==
    'will-inactivate'
  ) {
    return false;
  }

  // Claim enforcement revokes these as soon as inactivation is scheduled.
  if (ticket.collection_ticket_claim_id) return true;
  if (!ticket.expires_at) return true;
  return DateTime.fromISO(inactivateAt) < DateTime.fromISO(ticket.expires_at);
};
